import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DataLoader } from '../ContractChanges/ContractChangesDataLoader'
import { ContractChangesBanner } from '../ContractChanges/components/ContractChangesBanner/ContractChangesBanner'
import { ContractChangesView } from '../ContractChanges/ContractChangesView/ContractChangesView'
import { resolveContractTerminationTerminology } from '../ContractChanges/utils/resolveContractTerminationTerminology'
import { ContractChangesViewState } from '../ContractChanges/types'
import { ContractChangesSection } from '../../../common/types'
import { ResidentChangesForm } from './ResidentChangesForm'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { SidebarInfoSection, SidebarInfoSectionText } from 'components'
import { StyledLink } from 'components/StyledLink/StyledLink'

export const ResidentChanges: FC = () => {
  const [view, setView] = useState<ContractChangesViewState>('form')
  const { t } = useTranslation(['contractModification'])
  const { terminateContractPath } = useContractPaths()

  return (
    <DataLoader>
      {(data) => {
        const terminology = resolveContractTerminationTerminology(
          data.contract.contractType
        )

        return (
          <ContractChangesView
            title={t('contractModification:residentChanges.title')}
            banner={
              view === 'form' && (
                <ContractChangesBanner
                  contract={data.contract}
                  tenants={data.tenants}
                  otherSection={ContractChangesSection.TERMINATE_CONTRACT}
                />
              )
            }
            sidebarInfo={
              view === 'form' && (
                <SidebarInfoSection className="space-y-4">
                  <SidebarInfoSectionText>
                    {t('contractModification:residentChanges.description')}
                  </SidebarInfoSectionText>
                  <SidebarInfoSectionText>
                    {t(terminology.residentChangesTerminationInfo)}
                  </SidebarInfoSectionText>
                  <StyledLink to={terminateContractPath} className="block">
                    {t(terminology.residentChangesTerminationLink)}
                  </StyledLink>
                </SidebarInfoSection>
              )
            }
          >
            <ResidentChangesForm
              view={view}
              setView={setView}
              contract={data.contract}
              tenants={data.tenants}
              userMetadata={data.userMetadata}
            />
          </ContractChangesView>
        )
      }}
    </DataLoader>
  )
}
